var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('meetings-landing',{attrs:{"dashboard_id":_vm.dashboard_id},on:{"created":_vm.refreshMeetings,"attached":_vm.refreshMeetings}})}
var staticRenderFns = []

export { render, staticRenderFns }